// ============================================================================
// Table Columns: CustomPages
// Key: customPages
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
	iconEnumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	CustomPageDto,
	TeamCustomPageResponse,
	TeamSummary,
	UserCustomPageDto,
	UserDto,
} from '../api/backstage.schemas'
import { CustomPageIcon, LinkTarget } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const customPagesListColumnsConfig = {
	columns: [
		'displayName',
		'description',
		'url',
		iconEnumRenderer('icon', CustomPageIcon, 'CustomPageIcon'),
		cellRenderer('enabledForAllUsers', 'boolean'),
		cellRenderer('sortOrder', 'number'),
		enumRenderer('linkTarget', LinkTarget, 'LinkTarget'),
		cellRenderer('iFrameWidth', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: CustomPageDto) => `/customPages/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<CustomPageDto>
// #endregion

// #region Relation List Columns
// #region Relation: Teams
export const customPagesRelationsTeamsAssignedColumnsConfig = {
	columns: ['teamName', 'customPageName'],
} as const satisfies EntityTableConfig<TeamCustomPageResponse>
export const customPagesRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion

// #region Relation: Users
export const customPagesRelationsUsersAssignedColumnsConfig = {
	columns: [
		'userFirstName',
		'userLastName',
		'userEmail',
		'userLogonName',
		'customPageName',
	],
} as const satisfies EntityTableConfig<UserCustomPageDto>
export const customPagesRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
	],
} as const satisfies EntityTableConfig<UserDto>
// #endregion
// #endregion

// #region Columns Config Export
export const customPagesColumnsConfig = {
	list: customPagesListColumnsConfig,
	relations: {
		teams: {
			assigned: customPagesRelationsTeamsAssignedColumnsConfig,
			available: customPagesRelationsTeamsAvailableColumnsConfig,
		},
		users: {
			assigned: customPagesRelationsUsersAssignedColumnsConfig,
			available: customPagesRelationsUsersAvailableColumnsConfig,
		},
	},
} as const
// #endregion
